import { useLayoutEffect } from "react";
import "./App.scss";
import Home from "./pages/Home";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";
import { BrowserRouter } from "react-router-dom";
function App() {
  useLayoutEffect(() => {
    document.getElementById("boot-hero")?.remove();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <Home />
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
